export const educationData = [
    {
      id: 1,
      institution: "Masai School, Banglore",
      course: "Full Stack Web Development Course",
      startYear: "Jan 2022",
      endYear: "Nov 2022",
    },
    {
      id: 2,
      institution: "Punjabi University Patiala, Punjab",
      course: "Master of astronomy and Space Physics",
      startYear: "Jun 2016",
      endYear: "May 2018",
    },
    {
      id: 3,
      institution: "Panjab University Chandigarh",
      course: "Bachelor of Computer Science",
      startYear: "June 2013",
      endYear: "May 2016",
    },
  ];